import useTranslation from 'next-translate/useTranslation'
import { forwardRef } from 'react'
import IconSearch from '@/icons/24/magnifying-glass.svg'

interface SearchInputProps {
  searchTerm: string
  onSearchTermChange: (value: string) => void
}

export const SearchBar = forwardRef<HTMLInputElement, SearchInputProps>(
  ({ onSearchTermChange, searchTerm }, ref) => {
    const { t } = useTranslation()

    return (
      <div className="relative flex-grow flex items-center border-2 border-black rounded-md p-1">
        <div className="p-1">
          <IconSearch className="size-5" />
        </div>
        <input
          type="text"
          // Since interacting with the input is the only thing you can do on this page right now,
          // we can safely ignore the a11y warning. We should reconsider this when we add more
          // interactivity to the page.
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus
          placeholder={t('common:header.find_your_item_short')}
          value={searchTerm}
          onChange={(e) => onSearchTermChange(e.target.value)}
          className="flex-grow py-2 px-1 outline-none text-sm"
          ref={ref}
        />
        {searchTerm && (
          <button className="p-1" onClick={() => onSearchTermChange('')}>
            <div className="bg-gray-400 rounded-full size-4 flex items-center justify-center">
              <svg
                width="8"
                height="8"
                viewBox="0 0 8 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 0.805714L7.19429 0L4 3.19429L0.805714 0L0 0.805714L3.19429 4L0 7.19429L0.805714 8L4 4.80571L7.19429 8L8 7.19429L4.80571 4L8 0.805714Z"
                  fill="white"
                />
              </svg>
            </div>
          </button>
        )}
      </div>
    )
  },
)
